// Quick checks from the home's manuals, shown next to a warranty draft. The homeowner can always submit.
//   draft ready -> POST /warranty/v1/self-check -> steps + cited documents -> SelfCheckTip above the form
import { Document } from "@/api/rest/models/document";
import { NewWarrantyCaseResponseType } from "@/api/rest/models/warranty";

export interface SelfCheck {
  steps: string[];
  documents: Document[];
}

// Only a finished draft is worth a lookup; questions still being asked are not.
export const isSelfCheckDraft = (status: NewWarrantyCaseResponseType | undefined, isResponse: boolean | undefined) =>
  isResponse === true &&
  (status === NewWarrantyCaseResponseType.WARRANTY || status === NewWarrantyCaseResponseType.NO_WARRANTY);

// Cited ids in the order the backend ranked them; ids the homeowner cannot open are left out.
export const selfCheckDocuments = (documentIds: number[], documents: Document[]): Document[] =>
  documentIds.map((id) => documents.find((doc) => doc.id === id)).filter((doc): doc is Document => doc !== undefined);
